import RHRLogo from 'url:./resources/Icon.png';
import './twitch.css';

export default function TwitchInfo(){
	return <div className='twitchInfoPanel panel'>
		<h2>Twitch</h2>
		<div>
			<a href="https://twitch.tv/RomhackRaces">
				<img src={RHRLogo} alt="Romhack Races" />
				<p>
					Follow Romhack Races on Twitch for races every Saturday!
				</p>
			</a>
		</div>
	</div>
}